import GlobalMixin from '@/app/shared/mixins/global';

export default {
    mixins: [
        GlobalMixin,
    ],
    props: {
        title: {
            type: String,
            required: false,
            default: ''
        },
        moduleCode: {
            type: String,
            require: true,
            default: null
        },
    },
    data() {
        return {
            idPanel: null,
        }
    },
    computed: {
        acl(){
            return this.idPanel && this.moduleCode ? this.$store.getters.getAcl(this.moduleCode, this.idPanel) : {};
        },
        url(){
            return this.idPanel && this.moduleCode ? this.$store.getters.getUrl(this.moduleCode, this.idPanel) : {};
        },
        panel(){
            return this.idPanel && this.moduleCode ? this.$store.getters.getPanel(this.moduleCode, this.idPanel) : {};
        },
        stateTool(){
            return this.idPanel && this.moduleCode ? this.$store.getters.getStateTool(this.moduleCode, this.idPanel) : {};
        },
        activePanel() {
            return this.checkPermissionPanel(this.stateTool, this.idPanel);
        },
        titlePanel() {
            return this.title;
        },
        readonlyFormItem() {
            return false;
        },
    },
    methods: {
        openPanel(){
            return this.$store.dispatch(`${this.moduleCode}/openPanel`, this.idPanel);
        },
        togglePanel(){
            return this.$store.dispatch(`${this.moduleCode}/togglePanel`, this.idPanel);
        },
    }
}